import type { ProgramFilters } from "./types";

export const baseFilters: ProgramFilters = {
  type_ids: [],
  term_ids: [],
  host_institution_ids: [],
  status_ids: [],
  city_ids: [],
  marketplace: undefined,
};

export const MARKETPLACE_STATUS = {
  PUBLIC: "public",
  PRIVATE: "private",
};
